var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { useState, } from 'react';
import RemoteData from 'ts-remote-data';
import { useTimeout } from './useTimeout';
import { isElement } from 'react-is';
/**
 * Analagous to React's native `Suspense` component, `RemoteSuspense` is a panel
 * that can be used to wrap elements which expect synchronously-available data
 * until their data dependencies resolve.
 *
 * It is expected that most projects will wrap this in their own panel component
 * which uses the project's standard loading indicator.
 */
export const RemoteSuspense = (_a) => {
    var { data, loadingTimeout = 150, loadingFallback = null, failureFallback = () => null } = _a, props = __rest(_a, ["data", "loadingTimeout", "loadingFallback", "failureFallback"]);
    const [showLoading, setShowLoading] = useState(false);
    const isLoading = data === RemoteData.LOADING;
    useTimeout(() => setShowLoading(true), isLoading && loadingTimeout);
    if (!isLoading && showLoading)
        setShowLoading(false);
    if (data === RemoteData.NOT_ASKED)
        return React.createElement(React.Fragment, null);
    if (data === RemoteData.LOADING) {
        return React.createElement(React.Fragment, null, showLoading && loadingFallback);
    }
    if (RemoteData.isFailure(data))
        return (React.createElement(React.Fragment, null, typeof failureFallback === 'function' &&
            !isElement(failureFallback)
            ? failureFallback(data.error)
            : failureFallback));
    return React.createElement(React.Fragment, null, props.children(data));
};
